<div class="coworking-home-bookings-container">
  <div class="header">
    <div class="title">
      <div class="section-title">{{ "company-profile.total-consumption" | translate }}: {{ getTotalCowings }} Cowings</div>
      <span>{{ "coworking-home.bookings.description-company-plus" | translate }}</span>
    </div>
    <div class="filters-section" [formGroup]="filterForm">
      <div class="filter">
        <div class="datepicker-wrapper">
          <cowing-datepicker (click)="setDateStart($event)"></cowing-datepicker>
        </div>
      </div>
      <div class="filter">
        <div class="datepicker-wrapper">
          <cowing-datepicker (click)="setDateEnd($event)"></cowing-datepicker>
        </div>
      </div>
    </div>
  </div>
  <div class="table-header">
    <div class="head">
      {{ "coworking-home.bookings.table-headers.employee" | translate }}
    </div>
    <div class="head">
      {{ "coworking-home.bookings.table-headers.code" | translate }}
    </div>
    <div class="head">
      {{ "coworking-home.bookings.table-headers.municipality" | translate }}
    </div>
    <div class="head">
      {{ "coworking-home.bookings.table-headers.workspace" | translate }}
    </div>
    <div class="head">
      {{ "coworking-home.bookings.table-headers.space" | translate }}
    </div>
    <div class="head">
      {{ "coworking-home.bookings.table-headers.date" | translate }}
    </div>
    <div class="head">
      {{ "coworking-home.bookings.table-headers.duration" | translate }}
    </div>
    <div class="head">
      {{ "coworking-home.bookings.table-headers.hour" | translate }}
    </div>
    <div class="head">
      {{ "coworking-home.bookings.table-headers.price" | translate }}
    </div>
  </div>

  <div class="table-container" *ngIf="spendingsList.length">
    <div class="table" *ngFor="let spending of spendingsList">
      <div class="row">
        <div class="bold ellipsis">{{ spending.coworker.name }}</div>
        <div class="ellipsis">{{ spending.id }}</div>
        <div class="ellipsis">{{ spending.city }}</div>
        <div class="ellipsis">{{ spending.coworking }}</div>
        <div class="ellipsis">{{ spending.space }}</div>
        <div class="ellipsis">{{ spending.start_date }}</div>
        <div class="semibold ellipsis">{{ spending.duration.name }}</div>
        <div class="ellipsis">{{ spending.start_time }} a {{ spending.end_time }}</div>
        <div class="bold center ellipsis">{{ spending.cowings_spent }}</div>
      </div>
    </div>
    <div class="action-pagination">
      <div class="pagination">
        <img *ngIf="previousPage !== null" [src]="getLeftArrowIcon" alt="" (click)="setPreviousPage()" />
        <img *ngIf="previousPage === null" [src]="getDisabledLeftArrowIcon" alt="" />
        <span> {{ filterForm.get("page").value + 1 }} </span>
        <img *ngIf="nextPage !== null" [src]="getRightArrowIcon" alt="" (click)="setNextPage()" />
        <img *ngIf="nextPage === null" [src]="getDisabledRightArrowIcon" alt="" />
      </div>
    </div>
  </div>
  <div *ngIf="!spendingsList.length" class="table-empty">
    <img [src]="getCalendarIcon" alt="" />
    <span>{{ "coworker.bookings.no-bookings" | translate }}</span>
  </div>
</div>
